import { createSlice } from '@reduxjs/toolkit';

const appConfigSlice = createSlice({
  name: 'appConfig',
  initialState: {
    data: {
      langugae: 'en',
    },
  },
  reducers: {
    setLanguage: (state, action) => {
      state.data.langugae = action.payload;
    },
  },
});

export const { setLanguage } = appConfigSlice.actions;
export const selectCurrentLanguage = (state: any) =>
  state.appConfig.data.langugae;

export default appConfigSlice.reducer;
